import { observer } from 'mobx-react-lite';
import React from 'react'
import { useStore } from '../../../../../../../hooks/useStore'
import { PillButton } from '../../../../../../general/buttons/pill-button';

const MapFindMoreNonprofitsBtn = observer(() => {
    const {uiStore: {openHomeLocationList, home__map__activeCity}} = useStore();
    if (home__map__activeCity === "All cities") return null;

    return (
        <PillButton 
            invert
            onClick={openHomeLocationList}
            >
            Find More Nonprofits
        </PillButton>
    )
})

export default MapFindMoreNonprofitsBtn